import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';

function MarcaForm({ onSave, initialData, onCancel }) {
  const [nome, setNome] = useState('');

  useEffect(() => {
    if (initialData) {
      setNome(initialData.nome || '');
    } else {
      setNome('');
    }
  }, [initialData]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!nome.trim()) return;
    onSave({ ...initialData, nome });
    setNome('');
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
      <Typography variant="h6" gutterBottom>
        {initialData ? 'Editar Marca' : 'Adicionar Nova Marca'}
      </Typography>
      <TextField
        label="Nome da Marca"
        variant="outlined"
        fullWidth
        value={nome}
        onChange={(e) => setNome(e.target.value)}
        margin="dense"
        required
      />
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
        >
          {initialData ? 'Atualizar' : 'Salvar'}
        </Button>
        {initialData && (
          <Button
            type="button"
            variant="outlined"
            onClick={onCancel}
          >
            Cancelar
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default MarcaForm;
